import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ChecklistState = {
  [seq: number]: "ya" | "tidak";
};

const initialState: ChecklistState = {};

export const checklistSlice = createSlice({
  name: "ChecklistSlice",
  initialState,
  reducers: {
    setAnswer: (
      state,
      action: PayloadAction<{ seq: number; answer: "ya" | "tidak" }>
    ) => {
      const payload = action.payload;
      state[payload.seq] = payload.answer;
    },
    resetAnswers: () => {
      return initialState;
    },
  },
});

export default checklistSlice.reducer;
export const { setAnswer, resetAnswers } = checklistSlice.actions;
